const config = {
    type: 'MULTIMEDIA',
    component: "Smu05",
    portrait: "/img/container/S-MU-05.jpg",
    body: {
        title: '',
        image: "https://placehold.co/300x200?text=Selecciona+o+arrastra+tu+imagen",
        content: ''
    },
}

export { config }